/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import {useQuery} from 'react-query'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {resolveChartColor, withPremiumTheme} from './chart-theme'
import {Graphic5Type} from '../core/_models'
import {getGraphic5} from '../core/_requests'
import {useAuth} from '../../../../app/modules/auth'

type Props = {
  className: string
  chartColor: string
  chartHeight: string
}

const Graphic5: React.FC<Props> = ({ className, chartColor, chartHeight }) => {
  const {currentUser} = useAuth()
  const chartRef = useRef<HTMLDivElement | null>(null)
  const [refreshGraphic, setRefreshGraphic] = useState(false)

  const query = useQuery(
    'log_boxes-events',
    () => getGraphic5(currentUser!.last_company_id), {
    cacheTime: 0,
    refetchOnWindowFocus: false,
  })

  const refreshChart = () => {
    if (!chartRef.current || query.isFetching) {
      return
    }

    const chart1 = new ApexCharts(chartRef.current, chart1Options(chartColor, chartHeight, query.data))
    if (chart1) {
      chart1.render()
    }

    setRefreshGraphic(false)
    return chart1
  }

  useEffect(() => {
    query.refetch().then(() => {
      setRefreshGraphic(true)
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser])

  useEffect(() => {
    const chart1 = refreshChart()

    return () => {
      if (chart1) {
        chart1.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, query.data, refreshGraphic])

  return (
    <div className={className}>
      {(query.data && query.data.length > 0) ? (
        <div ref={chartRef} ></div>
      ) : (
        <div className='d-flex flex-1 justify-content-center align-items-center fs-7' style={{ color: '#9ca3af', minHeight: 220 }}>
          {query.isFetching ? (
            <div className="spinner-border text-secondary spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : 'Sem dados'}
        </div>
      )}
    </div>
  )
}

const chart1Options = (chartColor: string, chartHeight: string, data: Graphic5Type[] | undefined): ApexOptions => {
  const baseColor = resolveChartColor(chartColor);
  return withPremiumTheme({
    series: [{
      name: 'Total de caixas do projeto',
      data: data ? data.map((box) => box.total_boxes) : []
    }],
    chart: { type: 'bar', height: chartHeight },
    plotOptions: { bar: { horizontal: false, columnWidth: '60', borderRadius: 4 } },
    legend: { show: false },
    stroke: { show: false },
    xaxis: {
      categories: data ? data.sort((a, b) => b.total_boxes - a.total_boxes).map((box) => box.project_name) : [],
    },
    fill: { opacity: 0.95 },
    tooltip: {
      x: { formatter: (val) => 'Projeto: ' + val },
      y: { formatter: (val) => val.toString() },
    },
    colors: [baseColor],
  });
}

export { Graphic5 }
